import { render } from "./StudentsContent.vue?vue&type=template&id=2757e942&ts=true"
import script from "./StudentsContent.vue?vue&type=script&lang=ts"
export * from "./StudentsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__